import { AZFN_GET_DOWNLOAD } from "../common/constants"

export const getDownloadUrl = (filename) => {
    return `${AZFN_GET_DOWNLOAD}?f=${encodeURIComponent(filename).replace(/%2F/g, "/")}`
}